import { createEmptyOption, createSelectContent } from './SelectList.Helpers';
import React from 'react';
import SelectOption from '../../../infrastructure/types/SelectOption';
import ComponentType from '../../../types/report/ComponentType';

interface SelectListProps {
    options: SelectOption[];
    value: string;
    onChange: (value: string,
        e: React.ChangeEvent<HTMLElement>,
        text: string,
        number?: number,
        componentType?: ComponentType,
        innerType?: string,
        configId?: number,
        mainComponentNumber?: number) => void;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    className?: string;
    disabled?: boolean;
    includeEmptyOption?: boolean;
}

class SelectList extends React.Component<SelectListProps> {
    constructor(props: SelectListProps) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    onChange(e: React.ChangeEvent<HTMLSelectElement>): void {

        let option = this.props.options.find(x => x.value === e.target.value);

        let text = option?.text || '';

        let number = option?.number || 0;

        let componentType = option?.componentType || ComponentType.None;

        let innerType = option?.innerType || '';

        let configId = option?.configId || 0;

        let mainComponentNumber = option?.mainComponentNumber || 0;

        this.props.onChange(e.target.value, e, text, number, componentType, innerType, configId, mainComponentNumber);
    }

    onClick(e: React.MouseEvent<HTMLElement>) {
        this.props.onClick && this.props.onClick(e);
    }

    render(): JSX.Element {

        let prependOptions = this.props.includeEmptyOption ? [createEmptyOption()] : [];

        return (
            <div onClick={this.onClick}>
                <select
                    onChange={this.onChange}
                    value={this.props.value}
                    className={this.props.className}
                    disabled={this.props.disabled}>
                    {prependOptions.concat(createSelectContent(this.props.options))}
                </select>
            </div>
        );
    }
}

export default SelectList;